export const createRequestErrors = {
    "value_error.companyactiveinceregistry": "Компания уже проходит экспертизу на статус МТК",
    "value_error.companyalreadyinmtkregistry": "Компания уже включена в реестр МТК"
} as const

export type CreateRequestError = keyof typeof createRequestErrors
export type CreateRequestErrorValue = typeof createRequestErrors[CreateRequestError]